import React from 'react';
import AutoCourseGenerator from '../componets/AutoCourseGenerator/AutoCourseGenerator';

const AutoCourseGeneratorPage = () => {
  return <AutoCourseGenerator />;
};

export default AutoCourseGeneratorPage;